import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface Props {
    clickFunction: any,
    label: string,
    children: JSX.Element
    dataCypress?: string
    disabled?: boolean
    noWrapText?: boolean
}

const btnStyle = {
    '&.MuiButtonBase-root:hover': {
        bgcolor: 'transparent'
    },
    height: '70px'
}
const boxStyle = {
    height: '40px',
    width: '40px',
    padding: '10px',
    borderRadius: '50%',
}

function CCOCircleButton(props: Props) {
    return (
        <Button disabled={props.disabled} data-cypress={props.dataCypress} sx={btnStyle}
                       onClick={props.clickFunction}>
            <Stack
                direction='row'
                sx={{
                    alignItems: 'center',
                    gap: 2
                }}>
                <Box sx={{...boxStyle, backgroundColor: props.disabled ? '#cdcdcd' : 'primary.main'}}>
                    {props.children}
                </Box>
                <Typography
                    sx={{
                        textAlign: 'left',
                        color: props.disabled ? '#8B8B8B' : 'text.primary',
                        textWrapMode: props.noWrapText ? 'nowrap' : 'wrap'
                    }}>{props.label}</Typography>
            </Stack>
        </Button>
    );
}

export default CCOCircleButton
